// Legacy quest campaign shown as "Legacy Score"
export const LEGACY_CAMPAIGN_ID = "spicenet";
export const LEGACY_CAMPAIGN_GROUP_ID = "1";

// Mainnet partner campaign used for Reppo / Zentra
export const MAINNET_CAMPAIGN_ID = "spicenet-portal";
export const MAINNET_CAMPAIGN_GROUP_ID = "1";

// Temporary compatibility exports for parts of the app still on the old model.
// These remain unchanged until Dashboard / Apps / Leaderboard are migrated.
export const CAMPAIGN_ID = "spicenet";
export const CAMPAIGN_OLD_ID = LEGACY_CAMPAIGN_ID;
export const CAMPAIGN_GROUP_ID = "2";
export const CAMPAIGN_OLD_GROUP_ID = LEGACY_CAMPAIGN_GROUP_ID;

export const CAMPAIGN_CONFIG = {
  id: CAMPAIGN_ID,
  groupId: CAMPAIGN_GROUP_ID,
  oldId: CAMPAIGN_OLD_ID,
  oldGroupId: CAMPAIGN_OLD_GROUP_ID,
} as const;

export const LEGACY_CAMPAIGN_CONFIG = {
  id: LEGACY_CAMPAIGN_ID,
  groupId: LEGACY_CAMPAIGN_GROUP_ID,
} as const;

export const MAINNET_CAMPAIGN_CONFIG = {
  id: MAINNET_CAMPAIGN_ID,
  groupId: MAINNET_CAMPAIGN_GROUP_ID,
} as const;
